import React, { useState, useEffect } from "react";
import SideMenu from "./SideMenu";
import * as XLSX from "xlsx";
import {
    collection, query, where, getDocs, addDoc, Timestamp
} from "firebase/firestore";
import db from "./Firebase";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";


function EnrollCourse() {
    const [courses, setCourses] = useState([]); // list of all courses
    const [selectedCourse, setSelectedCourse] = useState(null);

    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [fileName, setFileName] = useState("");

    const [singlePhone, setSinglePhone] = useState("");
    const [singleEnrollMode, setSingleEnrollMode] = useState(false);

    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        setEmail(storedUsername);

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }

        // fetch all courses
        fetchAllCourses();
    }, []);

    const fetchAllCourses = async () => {
        try {
            const q = collection(db, "nv_courses");
            const snapshot = await getDocs(q);
            const fetched = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setCourses(fetched);
        } catch (error) {
            console.error("Error fetching courses:", error);
            Swal.fire("Error", "Could not load courses list.", "error");
        }
    };

    const handleCourseSelect = (e) => {
        const cid = e.target.value;
        const courseObj = courses.find(c => c.id === cid);
        setSelectedCourse(courseObj || null);
    };

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setFileName(file.name);
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(sheet);

            // assuming "contact" column in the Excel
            const phoneList = rows
                .map(row => String(row["contact"] || row["phone"] || row["phone_no"] || "")
                    .trim())
                .filter(Boolean);
            setPhoneNumbers(phoneList);
        };

        reader.readAsArrayBuffer(file);
    };

    const enrollUsers = async () => {
        if (!selectedCourse) {
            Swal.fire("Error", "Please select a course first!", "error");
            return;
        }
        if (phoneNumbers.length === 0 && (!singleEnrollMode || !singlePhone.trim())) {
            Swal.fire("Error", "No phone number(s) to enroll!", "error");
            return;
        }

        // build list of phones from both modes
        const phonesToEnroll = [
            ...phoneNumbers,
            ...(singleEnrollMode && singlePhone.trim() ? [singlePhone.trim()] : [])
        ];

        for (let phone of phonesToEnroll) {
            try {
                await addDoc(collection(db, "nv_enrolled_courses"), {
                    ...selectedCourse,
                    phone_no: phone,
                    enrolled_date: Timestamp.now(),
                    registered_date: Timestamp.now(),
                });
            } catch (error) {
                console.error(`Firestore Write Error for ${phone}:`, error);
            }
        }

        Swal.fire("Success", "Users enrolled successfully!", "success");

        // log
        const logEntry = {
            created_date: new Date(),
            email: email || "unknown",
            page: "EnrollCourse",
            action: `Enrolled for course ${selectedCourse.course_name || selectedCourse.id} for phones ${phonesToEnroll.join(", ")}`,
        };
        await addDoc(collection(db, "nv_backend_logs"), logEntry);
        console.log("Log entry added:", logEntry);

        // reset state
        setPhoneNumbers([]);
        setFileName("");
        setSinglePhone("");
        setSingleEnrollMode(false);
    };


    const downloadSampleExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet([
            { contact: "98765xxxxx" },
            { contact: "9123xxxxxx" },
        ]);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = "sample_phone_upload.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    const [sidebarOpen, setSidebarOpen] = useState(false);


    return (
        <>

            <SideMenu onToggle={setSidebarOpen} />


            {/* <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div> */}
            <div className={`main-content ${sidebarOpen ? "shifted" : ""}`}>
                <div className="p-3">
                    <div className="card-header pb-0 px-3 d-flex justify-content-between">
                        <h6 className="mb-2">📚 Enroll Users in Course</h6>
                    </div>

                    {/* Course Selection Dropdown */}
                    <div className="mb-3">
                        <label>Select Course:</label>
                        <select
                            className="form-control"
                            value={selectedCourse ? selectedCourse.id : ""}
                            onChange={handleCourseSelect}
                        >
                            <option value="">-- Select a course --</option>
                            {courses.map(c => (
                                <option key={c.id} value={c.id}>
                                    {c.course_name} ({c.course_id || c.id})
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Show Course Name / Details */}
                    {selectedCourse && (
                        <div className="alert" style={{ backgroundColor: "aquamarine" }}>
                            <strong>Course Details:</strong> {selectedCourse.course_name} — ID: {selectedCourse.course_id || selectedCourse.id}
                        </div>
                    )}

                    {/* Single Enrollment Mode Toggle */}
                    {/* <div className="mb-3">
                    <label>
                        <input
                            type="checkbox"
                            checked={singleEnrollMode}
                            onChange={() => setSingleEnrollMode(prev => !prev)}
                        />
                        {" "} Enroll Single User
                    </label>
                </div> */}

                    <div className="mb-3">
                        <button
                            className={`btn ${singleEnrollMode ? "btn-info" : "btn-outline-secondary"}`}
                            onClick={() => setSingleEnrollMode(prev => !prev)}
                            type="button"
                        >
                            {singleEnrollMode ? "✅ Single Enroll Mode ON" : "👤 Enroll Single User"}
                        </button>
                    </div>

                    {singleEnrollMode && (
                        <div className="mb-3">
                            <label>Phone Number:</label>
                            <input
                                type="text"
                                className="form-control"
                                value={singlePhone}
                                onChange={(e) => setSinglePhone(e.target.value)}
                                placeholder="Enter phone number"
                            />
                        </div>
                    )}

                    {/* File Upload */}
                    <div className="mb-3">
                        <label>Bulk Enrollment:</label>
                        <input
                            type="file"
                            className="form-control"
                            accept=".xlsx, .xls"
                            onChange={handleFileUpload}
                        />
                        {fileName && <small className="text-muted">📂 {fileName} uploaded</small>}

                        <button
                            className="btn btn-sm btn-outline-primary mt-2"
                            onClick={downloadSampleExcel}
                        >
                            📥 Download Sample Excel
                        </button>
                    </div>

                    {/* Show Phone Numbers in a Table */}
                    {phoneNumbers.length > 0 && (
                        <div className="mt-3">
                            <h5>📜 Uploaded Phone Numbers:</h5>
                            <table className="table table-bordered mt-2">
                                <thead className="thead-dark">
                                    <tr>
                                        <th>#</th><th>Phone Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {phoneNumbers.map((phone, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{phone}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <button className="btn btn-success mt-3" onClick={enrollUsers}>
                        🚀 Enroll Users
                    </button>
                </div>
            </div>
        </>
    );
}

export default EnrollCourse;


// import React, { useState, useEffect } from "react";


// import * as XLSX from "xlsx"; // For reading Excel files
// import { collection, query, where, getDocs, addDoc, Timestamp } from "firebase/firestore";
// import db from "./Firebase"; // Firestore instance
// import Swal from "sweetalert2";
// import { useNavigate, Link, useParams } from 'react-router-dom';



// function EnrollCourse() {
//     const [courseId, setCourseId] = useState(""); // Course ID input field
//     const [course, setCourse] = useState(null);
//     const [phoneNumbers, setPhoneNumbers] = useState([]);
//     const [fileName, setFileName] = useState("");
//     const navigate = useNavigate();
//     const [email, setEmail] = useState("");


//     useEffect(() => {
//         const storedUsername = localStorage.getItem("email");
//         const storedPassword = localStorage.getItem("password");
//         const storedRemember = localStorage.getItem("remember");

//         setEmail(storedUsername)

//         if (storedRemember === "false" || !storedUsername || !storedPassword) {
//             navigate('/signin');
//         }

//     }, []);


//     // **Fetch Course Details by ID**
//     const fetchCourseDetails = async () => {
//         if (!courseId.trim()) {
//             Swal.fire("Error", "Please enter a Course ID!", "error");
//             return;
//         }

//         const q = query(collection(db, "nv_courses"), where("course_id", "==", courseId.trim()));
//         const snapshot = await getDocs(q);

//         if (!snapshot.empty) {
//             setCourse(snapshot.docs[0].data()); // Store course details
//             Swal.fire("Success", "Course details loaded!", "success");
//         } else {
//             Swal.fire("Error", "Course not found!", "error");
//         }
//     };

//     // **Handle Excel Upload**
//     const handleFileUpload = async (event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         setFileName(file.name); // Store the file name
//         const reader = new FileReader();

//         reader.onload = (e) => {
//             const data = new Uint8Array(e.target.result);
//             const workbook = XLSX.read(data, { type: "array" });
//             const sheet = workbook.Sheets[workbook.SheetNames[0]];
//             const rows = XLSX.utils.sheet_to_json(sheet);

//             const phoneList = rows.map(row => String(row["contact"]).trim()).filter(Boolean);
//             setPhoneNumbers(phoneList);
//         };

//         reader.readAsArrayBuffer(file);
//     };

//     // **Enroll Users**
//     const enrollUsers = async () => {
//         if (!course) {
//             Swal.fire("Error", "Please fetch the course details first!", "error");
//             return;
//         }
//         if (phoneNumbers.length === 0) {
//             Swal.fire("Error", "No phone numbers uploaded!", "error");
//             return;
//         }

//         for (let phone of phoneNumbers) {
//             try {
//                 await addDoc(collection(db, "nv_enrolled_courses"), {
//                     ...course,
//                     phone_no: phone,
//                     enrolled_date: Timestamp.now(),
//                     registered_date: Timestamp.now(),
//                 });
//             } catch (error) {
//                 console.error(`Firestore Write Error for ${phone}:`, error);
//             }
//         }

//         Swal.fire("Success", "Users enrolled successfully!", "success");

//         // ✅ Add log entry in "nv_backend_logs"
//         const logEntry = {
//             created_date: new Date(), // Current timestamp
//             email: email || "unknown", // Fallback if email is missing
//             page: "EnrollCourse",
//             action: `Enrolled for course ID: ${courseId} for phones ${phoneNumbers}`,
//         };

//         await addDoc(collection(db, "nv_backend_logs"), logEntry);
//         console.log("Log entry added:", logEntry);
//         setPhoneNumbers([]); // Clear after enrolling
//         setFileName("");
//     };

//     return (
//         <>
//             <div className="p-2 d-flex justify-content-between">
//                 <Link to="/">
//                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
//                 </Link>
//             </div>

//             <div className="p-3">
//                 <div className="card-header pb-0 px-3 d-flex justify-content-between">
//                     <h6 className="mb-2">📚 Enroll Users in Course</h6>

//                 </div>

//                 <div className="card-header pb-0 px-3 d-flex justify-content-between mb-3">
//                     <div className="mb-3">
//                         <label className="">Enter Course ID:</label>
//                         <input
//                             type="text"
//                             className="form-control"
//                             value={courseId}
//                             onChange={(e) => setCourseId(e.target.value)}
//                             placeholder="Enter Course ID"
//                         />
//                     </div>
//                     <button className="btn btn-primary mb-3" onClick={fetchCourseDetails}>Fetch Course Details</button>
//                 </div>

//                 {/* Show Course Name */}
//                 {course && (
//                     <div className="alert" style={{ backgroundColor: "aquamarine" }}>
//                         <strong>Course Name:</strong> {course.course_name}
//                     </div>
//                 )}


//                 {/* File Upload */}
//                 <div className="mb-3">
//                     <input
//                         type="file"
//                         className="form-control"
//                         accept=".xlsx, .xls"
//                         onChange={handleFileUpload}
//                     />
//                     {fileName && <small className="text-muted">📂 {fileName} uploaded</small>}
//                 </div>


//                 {/* Show Phone Numbers in a Table */}
//                 {phoneNumbers.length > 0 && (
//                     <div className="mt-3">
//                         <h5>📜 Uploaded Phone Numbers:</h5>
//                         <table className="table table-bordered mt-2">
//                             <thead className="thead-dark">
//                                 <tr>
//                                     <th>#</th>
//                                     <th>Phone Number</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {phoneNumbers.map((phone, index) => (
//                                     <tr key={index}>
//                                         <td>{index + 1}</td>
//                                         <td>{phone}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}

//                 {/* Enroll Button */}
//                 <button className="btn btn-success mt-3 justify-content-end" onClick={enrollUsers}>🚀 Enroll Users</button>
//             </div>
//         </>
//     );
// }

// export default EnrollCourse;



// // import React, { useState } from "react";
// // import * as XLSX from "xlsx"; // For reading Excel files
// // import { collection, query, where, getDocs, addDoc, Timestamp } from "firebase/firestore";
// // import db from "./Firebase"; // Firestore instance
// // import Swal from "sweetalert2";

// // function EnrollCourse() {
// //     const [course, setCourse] = useState(null);
// //     const [phoneNumbers, setPhoneNumbers] = useState([]);

// //     // **Fetch Course Details by ID**
// //     const fetchCourseDetails = async () => {
// //         const q = query(collection(db, "nv_courses"), where("course_id", "==", "005"));
// //         const snapshot = await getDocs(q);
// //         if (!snapshot.empty) {
// //             setCourse(snapshot.docs[0].data()); // Store course details
// //             console.log(snapshot.docs[0].data())
// //             Swal.fire("Success", "Course details loaded!", "success");
// //         } else {
// //             Swal.fire("Error", "Course not found!", "error");
// //         }
// //     };

// //     // **Handle Excel Upload**
// //     const handleFileUpload = async (event) => {
// //         const file = event.target.files[0];
// //         const reader = new FileReader();

// //         reader.onload = (e) => {
// //             const data = new Uint8Array(e.target.result);
// //             const workbook = XLSX.read(data, { type: "array" });
// //             const sheet = workbook.Sheets[workbook.SheetNames[0]];
// //             const rows = XLSX.utils.sheet_to_json(sheet);

// //             const phoneList = rows.map(row => row["Phone Number"]); // Column name must be "Phone Number"
// //             setPhoneNumbers(phoneList);
// //             console.log(phoneList);
// //             Swal.fire("Success", `Loaded ${phoneList.length} phone numbers!`, "success");
// //         };

// //         reader.readAsArrayBuffer(file);
// //     };

// //     // **Enroll Users**
// //     // const enrollUsers = async () => {
// //     //     if (!course) {
// //     //         Swal.fire("Error", "Please fetch the course details first!", "error");
// //     //         return;
// //     //     }
// //     //     if (phoneNumbers.length === 0) {
// //     //         Swal.fire("Error", "No phone numbers uploaded!", "error");
// //     //         return;
// //     //     }

// //     //     for (let phone of phoneNumbers) {
// //     //         console.log(phone)
// //     //         console.log("Course Data:", course);

// //     //         try {
// //     //             await addDoc(collection(db, "nv_enrolled_courses"), {
// //     //                 ...course,
// //     //                 phone_no: phone,
// //     //                 enrolled_date: Timestamp.now(),
// //     //                 registered_date: Timestamp.now(),
// //     //             });
// //     //             console.log("updateddddddddddd");
// //     //         } catch (error) {
// //     //             console.error("Error enrolling user:", error);
// //     //         }
// //     //     }

// //     //     Swal.fire("Success", "Users enrolled successfully!", "success");
// //     // };
// //     const enrollUsers = async () => {
// //         if (!course) {
// //             Swal.fire("Error", "Please fetch the course details first!", "error");
// //             return;
// //         }
// //         if (!Array.isArray(phoneNumbers) || phoneNumbers.length === 0) {
// //             Swal.fire("Error", "No phone numbers uploaded!", "error");
// //             return;
// //         }

// //         console.log("Starting enrollment...");
// //         console.log("Course Data:", course);
// //         console.log("Phone Numbers:", phoneNumbers);

// //         for (let phone of phoneNumbers) {
// //             const formattedPhone = String(phone).trim();
// //             console.log(`\n📞 Enrolling: ${formattedPhone}, Type: ${typeof formattedPhone}`);

// //             try {
// //                 await addDoc(collection(db, "nv_enrolled_courses"), {
// //                     ...course,
// //                     phone_no: formattedPhone,
// //                     enrolled_date: Timestamp.now(),
// //                     registered_date: Timestamp.now(),
// //                 });
// //                 console.log(`✅ Successfully enrolled: ${formattedPhone}`);
// //             } catch (error) {
// //                 console.error(`❌ Firestore Write Error for ${formattedPhone}:`, error);
// //             }
// //         }

// //         Swal.fire("Success", "Users enrolled successfully!", "success");
// //     };


// //     return (
// //         <div className="p-3">
// //             <h3>Enroll Users in Course</h3>

// //             {/* Fetch Course Button */}
// //             <button className="btn btn-primary mb-3" onClick={fetchCourseDetails}>Fetch Course Details</button>

// //             {/* File Upload */}
// //             <input type="file" className="form-control mb-3" accept=".xlsx, .xls" onChange={handleFileUpload} />

// //             {/* Enroll Button */}
// //             <button className="btn btn-success" onClick={enrollUsers}>Enroll Users</button>
// //         </div>
// //     );
// // }

// // export default EnrollCourse;
